const user_scopes = {
    descriptions: {
        custom_data: 'Dữ liệu tùy chỉnh của bạn',
        email: 'Địa chỉ email của bạn',
        phone: 'Số điện thoại của bạn',
        profile: 'Tên, tên đăng nhập, ảnh đại diện và thông tin hồ sơ khác của bạn',
        roles: 'Vai trò của bạn',
        identities: 'Danh tính mạng xã hội đã liên kết của bạn',
        'urn:logto:scope:organizations': 'Thông tin tổ chức của bạn',
        'urn:logto:scope:organization_roles': 'Vai trò tổ chức của bạn',
        address: 'Địa chỉ của bạn',
        'urn:logto:scope:sessions': 'Phiên đăng nhập đang hoạt động của bạn',
        'urn:logto:scope:trusted_devices': 'Thiết bị tin cậy của bạn',
    },
};
export default Object.freeze(user_scopes);
